import api from './api'; // tu wrapper axios/fetch

const reportService = {
  getOverview: (params) => api.get('/reports/overview', { params }),
  getUserActivity: (params) => api.get('/reports/user-activity', { params }),
  getUserActivityDetailed: (params) => api.get('/reports/user-activity-detailed', { params }),
  getMatches: (params) => api.get('/reports/matches', { params }),
  getAchievements: (params) => api.get('/reports/achievements', { params }),
  sendBulkEmails: (estado, usuarios) => api.post('/reports/send-bulk-emails', { estado, usuarios }),
  getNuevosFutbolistas: (torneoId) => api.get('/reports/nuevos-futbolistas', { params: { torneo_id: torneoId } }),
  getEstadisticasJornadas: (torneoId) => api.get('/reports/estadisticas-jornadas', { params: { torneo_id: torneoId } }),
  getEstadisticasPromos: (torneoId) => api.get('/reports/estadisticas-promos', { params: { torneo_id: torneoId } }),
  getComprasPrimeraExperiencia: (torneoId) => api.get('/reports/compras-primera-experiencia', { params: { torneo_id: torneoId } }),
  getComprasPacks: (torneoId) => api.get('/reports/compras-packs', { params: { torneo_id: torneoId } }),
};

export default reportService;